import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  reviewsPageBuy: {
    id: 'reviewsPage.buy',
    defaultMessage: 'Koupit',
  },
  reviewsPageTitle: {
    id: 'reviewsPage.title',
    defaultMessage: 'Recenze {productFullName}',
  },
});
